const comunMainTextClasses =
  'inline-block font-bold font-gil text-14 leading-24';

const theme = {
  solid: {
    text: `${comunMainTextClasses} text-base-main`,
    textLink: `${comunMainTextClasses} text-base-main hover:text-secondary-main`,
    textIcon: 'iconWrapper-grey',
    icon: 'iconWrapper-lightblue',
  },
  transparent: {
    text: `${comunMainTextClasses} text-white`,
    textLink: `${comunMainTextClasses} text-white`,
    textIcon: 'iconWrapper-white',
    icon: 'iconWrapper-white',
  },
  dark: {
    text: `${comunMainTextClasses} text-base-main`,
    textLink: `${comunMainTextClasses} text-white`,
    textIcon: 'iconWrapper-white',
    icon: 'iconWrapper-white',
  },
};

export default theme;
